export class ListGitIntegrationsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "integrations",
            "baseName": "integrations",
            "type": "Array<GitIntegration>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGitIntegrationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
